import { motion } from "framer-motion";
import React from 'react';

const HeroAnimation = () => {
  return (
    <motion.div
    className="w-[100dvw] h-[800px] bg-[#fff]"
    >

    </motion.div>
  )
}

export default HeroAnimation